import "core-js/es/promise";
import launchDarklyService from './services/launchDarklyService';

// Initialize LaunchDarkly service
launchDarklyService.initialize('65ce71cd7197a00fe9e632b8', {
  key: 'launch_darkly_office_TEST',
  anonymous: true
});

launchDarklyService.onReady(() => {
  //browserSupport.js is specifically for IE11
  if (!Object.entries && !Array.prototype.find && !Array.prototype.includes) {
    import("./browserSupport.js").then(() => {
        import("./app.js"); // eslint-disable-line no-unused-expressions
    });
  } else {
    import("./app.js"); // eslint-disable-line no-unused-expressions
  }
});